/* eslint-disable @typescript-eslint/no-explicit-any */
import L from "leaflet";
import $ from "jquery";

interface ControlBoundFilterOptions extends L.ControlOptions {
  title?: string;
}

(L.Control as any).ControlBoundFilter = (L.Control as any).extend({
  // @section
  // @aka Control.Zoom options
  options: {
    position: "topright",
    title: "Map filter",
  } as ControlBoundFilterOptions,

  onAdd: function (map: L.Map): HTMLElement {
    const activated = "leaflet-control-custom-bound-filter-activated";
    const deactivated = "leaflet-control-custom-bound-filter-deactivated";

    const a = $(
      '<div class="' +
        deactivated +
        ' leaflet-bar" title="' +
        this.options.title +
        '"><a class="" javascript:void(0)></a></div>'
    );

    function handleEvent(e: Event): void {
      const data = (e as CustomEvent).detail;

      const isActivated = data.switchOn;
      const oldClass = !isActivated ? activated : deactivated;
      const newClass = !isActivated ? deactivated : activated;
      a.removeClass(oldClass).addClass(newClass);
    }

    this._handleEvent = handleEvent;

    // Listen for the custom event
    document.addEventListener("bound_switch_react_change", handleEvent);

    a.on("click", function () {
      map.fire("custom_bound_filter", {
        switchOn: a.hasClass(activated) ? false : true,
      });
    });

    a.on("dblclick", function (e) {
      (e.originalEvent as Event)?.stopPropagation();
    });

    return a[0];
  },

  onRemove: function (_map: L.Map): void {
    document.removeEventListener(
      "bound_switch_react_change",
      this._handleEvent
    );
  },
});

export const ControlBoundFilter = function (
  opts?: ControlBoundFilterOptions
): any {
  return new (L.Control as any).ControlBoundFilter(opts);
};
